


























import { Vue, Component, Watch } from 'vue-property-decorator';
import { SpaceDetailTabs } from '@/config/map.conf';
import * as api from '@/api';

/**
 * 空间详情
 *
 * @author liyuyao
 * @date 08/10/2020
 */
@Component({
    components: {}
})
export default class SpaceDetail extends Vue {
    tabs: CommonTypes.valueLabel[] = SpaceDetailTabs;
    activeName: string = 'space_admin';
    spaceDetailInfo: CommonTypes.mapObject = {
        name: '测试标题',
        formListLink: '',
        accessLink: ''
    };
    @Watch('$route.name', { immediate: true })
    onRouterChange(routeName) {
        const includesRoute = SpaceDetailTabs.map(item => item.value).includes(routeName);
        // this.activeName = routeName.includes('space_template') ? 'space_template' : ( includesRoute ? routeName : 'space_admin');
        this.activeName = includesRoute ? routeName : 'space_admin';
    }
    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }
    mounted() {
        this.getSpaceDetail();
    }
    async getSpaceDetail() {
        try {
            const res = await api.spaceApi.getSpaceDetail(this.spaceId);
            const { code, data } = res;
            if (code === 200) {
                this.spaceDetailInfo.name = data.name;
                this.spaceDetailInfo.formListLink = data.formListLink;
                this.spaceDetailInfo.accessLink = data.accessLink;
            }
        } catch (e) {
            console.log(e);
        }
    }
    goback() {
        this.$router
            .push({
                name: 'space'
            })
            .catch(e => e);
    }
    handleChangeTab() {
        this.$router
            .push({
                name: this.activeName
            })
            .catch(e => e);
    }
    handleCopySuccess() {
        this.$mtd.message.success('复制成功');
    }
}
